module.exports = __webpack_public_path__ + "static/sport/title-pc.061d087.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/title-pc.png
// module id = KAi6
// module chunks = 0